import React from "react";
import { getPatientById
,addJobFile,getJobFiles,getlatestSTlFiles,getMenus,deleteNotes, addJobNotes,deleteJobFile,getJobNotes,getRoles,convert,s3UploadWithOptions, getSchedules,
getAccounts, signedUrlDP,s3Upload,addFile,getFile,updateMaster,getFileAnnotation,getJobStatus,getJobById, approve, reject
 } from "../../crud/auth.crud";
 import { Link } from "react-router-dom";
 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormGroup from '@material-ui/core/FormGroup';
import FileUploadPreview from './FileUploadPreview';


import EditIcon from '@material-ui/icons/Edit';		
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ReactS3Uploader from "react-s3-uploader"
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { Figure } from "react-bootstrap";
import S3Image from "../../widgets/S3Image";
import CalendarEventsByPentity from "../../widgets/CalendarEventsByPentity";
import listPlugin from '@fullcalendar/list';
import { RectangleSelector} from 'react-image-annotation/lib/selectors'
import Annotation from 'react-image-annotation'
import {MenuItem} from "@material-ui/core";
import {  format } from 'date-fns'
import Draggable from 'react-draggable';
import FFMPEG from "react-ffmpeg";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import DeleteIcon from '@material-ui/icons/Delete';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import Alert from '@material-ui/lab/Alert'
import CircularProgress from '@material-ui/core/CircularProgress';

import axios from "axios";

import { ReactMediaRecorder } from "react-media-recorder";

import Paper from '@material-ui/core/Paper';

import CalendarToday from '@material-ui/icons/CalendarToday';

import Share from '@material-ui/icons/Share';

import AudiotrackIcon from '@material-ui/icons/Audiotrack';

import VideocamOffRoundedIcon from '@material-ui/icons/VideocamOffRounded';

import MusicVideoIcon from '@material-ui/icons/MusicVideo';

import StopIcon from '@material-ui/icons/Stop';


import ListAlt from '@material-ui/icons/ListAlt';
import { Tooltip,IconButton } from "@material-ui/core";  
import ReactAudioPlayer from 'react-audio-player';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel'

import Checkbox from '@material-ui/core/Checkbox';
import {Recorder} from 'react-voice-recorder'
import './voice.css'

import Chat from './Chat';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ErrorOutlineRounded } from "@material-ui/icons";

import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import EditJobrStatus from './EditJobrStatus';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SkipNextIcon from '@material-ui/icons/SkipNext';

                  
export default class ViewPatient extends React.Component
{

	
	state = {
		audioDetails : {
url: null,
blob: null,
chunks: null,
duration: {
h: null,
m: null,
s: null,
}
},
    	patients:[],
    	templates:[],
    	menu: false,
    	open:false,
    	annotations: [],
    annotation: {},
    type:'RECTANGLE',
    fileKey:'',
    status:false,
    downloadUrl:'',
    fileType:'',
    id:'',
    input:'',
    mStatus:[],
    permission:[],
    fromPath:'',
    postObj:{},
    page:1,
	finalSTL:[],
    todoView:'calendar',
    Referral:'',
    Practice:'',
	previewLoading: false,
	currentPreview:0,
    mediaBlobUrl:null,
    videoOpen:false,
	videoRecord:false,
	videoDetails:false,
	uploadComplete:false,
	users:[],
	shareOpen:false,
	fileKey:'',
	userKey:'',
	previewFile:null,
	shareStatus:false,
	mediaapisupport:false,
	files:[],
	stlOpen:false,
	statusOpen:false,
	jobRequest:null,
	jobStatus: '',
	fileTagging:null,
	tags:[],
	fieldGroups:[],
	extractionTop:[],
	extractionBottom:[],
	fileApproval:null,
	statusMap:{},
  	}
	
	
constructor(props)
{
	let mediaapisupport = false;
	
  
super(props);
  this.state = {
  	audioDetails : {
url: null,
blob: null,
chunks: null,
duration: {
h: null,
m: null,
s: null,
}
},
      menu: false,
      patients:[],
      templates:[],
      mAccounts:[],
      //patient:this.props.location.data,
      fromPath:'',
      imageUrl:'media/misc/loading.gif',
      imageOpen:false,
      annotations: [],
	    annotation: {},
	    type:'RECTANGLE',
	    fileKey:'',
	    status:false,
	    downloadUrl:'',
	    fileType:'',
	    id:'',
	    input:'',
		finalSTL:[],
	    statusFlag:false,
    statusMessage:'',
     statusColor:'alert-success',
     mStatus:[],
     permission:[],
     postObj:{},
     page:1,
	 previewLoading:false,
     todoView:'calendar',
     Referral:'',
    Practice:'',
    mediaBlobUrl:null,
    videoOpen:false,
	previewFile:null,
	videoRecord:false,
	videoDetails:false,
	uploadComplete:false,
	users:[],
	shareOpen:false,
	fileKey:'',
	userKey:'',
	shareStatus:false,
	mediaapisupport:mediaapisupport,
	jobRequestDbId:'',
	files:[],
	stlOpen:false,
	statusOpen:false,
	jobRequest:null,
	jobStatus :'',
	fileTagging:null,
	currentPreview:0,
	tags:[],
	fileApproval:null,
	statusMap:{},
	extractionTop:
      {
        "fieldName": "extractions1",
        "displayName": "Top",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "top",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16"
        ],
        "items": null,
        "imagePath": [
          "media/misc/etop1.png",
          "media/misc/etop2.png",
          "media/misc/etop3.png",
          "media/misc/etop4.png",
          "media/misc/etop5.png",
          "media/misc/etop6.png",
          "media/misc/etop7.png",
          "media/misc/etop8.png",
          "media/misc/etop9.png",
          "media/misc/etop10.png",
          "media/misc/etop11.png",
          "media/misc/etop12.png",
          "media/misc/etop13.png",
          "media/misc/etop14.png",
          "media/misc/etop15.png",
          "media/misc/etop16.png"
        ],
        "lookUp": null
      },
      extractionBottom:{
        "fieldName": "extractions2",
        "displayName": "Bottom",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "bottom",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "32",
          "31",
          "30",
          "29",
          "28",
          "27",
          "26",
          "25",
          "24",
          "23",
          "22",
          "21",
          "20",
          "19",
          "18",
          "17"
        ],
        "items": null,
        "imagePath": [
          "media/misc/ebottom32.png",
          "media/misc/ebottom31.png",
          "media/misc/ebottom30.png",
          "media/misc/ebottom29.png",
          "media/misc/ebottom28.png",
          "media/misc/ebottom27.png",
          "media/misc/ebottom26.png",
          "media/misc/ebottom25.png",
          "media/misc/ebottom24.png",
          "media/misc/ebottom23.png",
          "media/misc/ebottom22.png",
          "media/misc/ebottom21.png",
          "media/misc/ebottom20.png",
          "media/misc/ebottom19.png",
          "media/misc/ebottom18.png",
          "media/misc/ebottom17.png"
        ],
        "lookUp": null
      }
    
    };
  
  console.log("patient id"+this.props.location.data);
  this.toggleMenu = this.toggleMenu.bind(this);
  
}


handleDeleteFile=(id)=>
{
	//console.log("id",this.state.id);
	if (window.confirm("Are you sure you want to delete this file?")) 
    {
		deleteJobFile(id).then(response => response.data)
		.then((data) => {
		
		getJobFiles(this.state.jobRequestDbId).then(response => response.data)
				.then((data) => {
					let files = data;
						let tags =[];
						files.map((f)=>{
							if (tags.indexOf(f.fileTag) === -1) {
								tags.push(f.fileTag)
							}
						});

						this.setState({ files:data, tags:tags});
					
					});
		});
	}
}

updateStatus=(jobr)=>
	{
  
		if(this.state.mStatus!=null)
			{
				//console.log("fsts::::","here",data.jobRequestKey);	
				this.state.mStatus.filter(sts=> sts.jobStatusId===jobr.jobStatusId).map((fsts)=>{
					this.setState({jobStatus:fsts.jobStatusName})
					console.log("fsts::::",fsts);	
					})
			}	
  
	}
	
	 handleChange = (event) => {
    this.setState({fileTagging:event.target.value});
  };


onChange = (annotation) => {
    this.setState({ annotation })
  }

  onSubmit = (annotation) => {
    const { geometry, data } = annotation

    this.setState({
      annotation: {},
      annotations: this.state.annotations.concat({
        geometry,
        data: {
          ...data,
          id: Math.random()
        }
      })
    })
  }
onInput(e) {
    this.setState({
      input: e.target.value
    })
  }

  onSelectTag=(e,value)=> {
	console.log("eeeee",e);
	let tguser=[];
	  if(value !== null && value !== undefined)
	  {
		console.log("value",value);
		
		this.setState({userKey:value.userId});
	  }
	}

	

  sendMessage=()=>
  {
  	if(this.state.input!=='')
  	{
	  	let notesObj = {
	  		notes: this.state.input
	  	}
		addJobNotes(this.state.jobRequestDbId,notesObj)
	                      .then(resp => {
	                        //props.register(accessToken);
	                       
	                        console.log(resp);
	                        getJobNotes(this.state.jobRequestDbId).then((response) => {
					      	console.log("notes:::",response);
					  		this.setState({notes:response.data,input:''})
					      });
	                       
                      })
    }
  }


saveAnnotation = () =>
{

	 let data  = {
                      'annotations' : {'annotate':this.state.annotations}
                   
                    };

	updateMaster('files',this.state.fileKey,data)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({annotations:[],annotation:{},fileKey:'',status:true})
                       
                      })
}
handleClose = () =>
  {
    this.setState({open:false});
  }

  imageClose = () =>
  {
    this.setState({imageOpen:false,audioKey:null, audioUrl:null});
  }

  audioClose = () =>
  {
    this.setState({audioOpen:false});
  }

  videoClose = () =>
  {
    this.setState({videoOpen:false});
  }

  shareClose = () =>
  {
    this.setState({shareOpen:false});
  }

  vRecordClose = () =>
  {
	  this.setState({videoRecord:false});
  }
handleOpen = () =>
  {
    this.setState({open:true,fileTagging:null});
  }

 fileCategory=(files,category) =>
 {

 	let ret = [];
 	console.log(category,this.state[category]);
 	files.map((x)=>{
 		console.log(x.createdByRoleKey)
 		if(this.state[category].includes(x.createdByRoleKey))
 		{
 			ret.push(x);
 		}
 	}

 	)

 	return ret;
 }

getSignedUrl = (file, callback) =>
  {
    //this.setState({open:true});
    console.log("getSignedUrl");
    const params = {
    objectName: file.name,
    contentType: file.type
  };
    console.log(params);
	signedUrlDP({ params })
	  .then(data => {
	    //callback(data.data);
	    //console.log(data.data);
	   // s3Upload(data.data.signedUrl,file,{headers:{'x-amz-acl': 'public-read','Content-Type' : params.contentType}})
	    s3Upload(data.data.signedUrl,file)
	    .then(response => response.data)
		    .then((data) => {
		     
		      	console.log(data);
		     });
	  })
	  .catch(error => {
	    //console.log(error);
	  });

}

 getUploadParams = async  ({ file, meta: { name } }) => {

		console.log(this.state.jobRequestDbId);
		let id = this.state.jobRequestDbId;
		let url ="";
		await signedUrlDP({ name,id })
		.then(data => {
			url = data.data.signedUrl;
			
		})
		console.log("url 2===="+name + "---id:"+id);
		//console.log("url===="+ url);
		//console.log(file);
		return { body: file, meta: {}, url:  url,method:'PUT'}
	
 }



   handleSubmit = (files, allFiles) => {
    //console.log(files.map(f => f.meta))
    //allFiles.forEach(f => f.remove())
    //console.log('here');
    //files.map((f) => (
    		//console.log(f.meta)
    	//))
  }

  imageView = async (id,previewFileKey,fileKey,originalFileKey,fileType) => {
  	console.log("filekey",fileKey,id);

  	var url='';

	url=originalFileKey;
	
	console.log("fileType::::",fileType);

	let mediaapisupport = false;
	
  	this.setState({imageUrl:'media/misc/loading.gif',imageOpen:true,id:fileKey,originalFileKey:url,fileType:fileType,mediaapisupport:mediaapisupport});
  	await getFile(id,url).then(response => response.data)
	      .then((data) => {
	      	this.setState({imageUrl: data.downloadUrl,fileKey:fileKey,status:false,fileType:fileType})
	      });
	

	
  }

  stlView = async (id,previewFileKey,fileKey,originalFileKey,fileType) => {
	console.log("filekey",fileKey,id);

	var url='';
    url=originalFileKey;  
  	console.log("fileType::::",fileType); 
 
	this.setState({imageUrl:'media/misc/loading.gif',stlOpen:true,id:fileKey,originalFileKey:url,fileType:fileType});
	await getFile(id,url).then(response => response.data)
		.then((data) => {
			this.setState({imageUrl: data.downloadUrl,fileKey:fileKey,status:false,fileType:fileType})
		});
  

  
}



 //read querystring 
 getQueryVariable=(variable)=>
 {
	   var query = window.location.search.substring(1);
	   //console.log(query)//"app=article&act=news_content&aid=160990"
	   var vars = query.split("&");
	   //console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
	   for (var i=0;i<vars.length;i++) {
				   var pair = vars[i].split("=");
				   //console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
	   if(pair[0] == variable){return pair[1];}
		}
		return(false);
 }

  updateStatus(pentity)
  {
  		console.log(pentity);
  		let data ={'status':this.state.tStatus};
  		updateMaster('pentity',pentity.pEntityId,data)
  		.then((response) => {
  			console.log("update status::::",response);
  			if(response.data !='Success')
  			{
  			 this.setState({open:false,statusFlag:true,statusMessage:response.data,statusColor:'alert-danger'});
  			}
  			else
  			{
  			 this.setState({open:false,statusFlag:false,statusFlag:true,statusMessage:'Status updated successfully',statusColor:'alert-success'});
  			 //this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el, status :this.state.tStatus}: el))});	
  		
  			}
  			 window.scrollTo(0,0);

  		})
  }

delete=()=>
{
	//console.log("id",this.state.id);
	deleteJobFile(this.state.id).then(response => response.data)
    .then((data) => {
      
      //getPatientById(this.state.patient.id).then(response => response.data)
	  //  .then((data) => {
	  //    this.setState({ patients: data ,imageOpen:false,id:''})
	     // console.log(data);
	  //   });
     });
}



handleRest()
{
	const reset = {
		url: null,
		blob: null,
		chunks: null,
		duration: {
			h: null,
			m: null,
			s: null,
		}
	}
this.setState({ audioDetails: reset });
}

PaperComponent(props) {
  return (
    <Draggable handle="#audio-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

loadImage=()=>{
	getFile(this.state.id,this.state.originalFileKey).then(response => response.data)
	      .then((data) => {
	      	this.setState({imageUrl: data.downloadUrl,fileKey:this.state.fileKey,status:false})
	      });
}

 Layout = ({ input, previews, submitButton, dropzoneProps, files, extra: { maxFiles } }) => {
  return (
    <div>
      {previews}

      <div {...dropzoneProps}>
        {files.length < maxFiles && input}
      </div>

      {files.length > 0 && submitButton}
    </div>
  )
}

 handleChangeStatus = ({ meta }, status) => {
    //console.log(status, meta)
	const fileId = meta.id;

    let id = this.state.jobRequestDbId;
    if(status=="done")
    {

    	addJobFile(id,meta.name,meta.size,meta.type,"",this.state.fileTagging).then(response => response.data)
	      .then((data) => {
	      		getJobFiles(id).then(response => response.data)
			   .then( (data) => {
			     let files = data;
					let tags =[];
					let finalSTL=[];
					files.map(async (f)=>{
						if (tags.indexOf(f.fileTag) === -1) {
							tags.push(f.fileTag)
						}
						if(f.fileTag.toLowerCase()==="final stl")
							{
								if(f.fileName.includes(".stl")||f.fileName.includes(".png")||f.fileName.includes(".jpg")||f.fileName.includes(".jpeg"))
								{
									if(finalSTL.length===0)
									{
										await getFile(f.id,f.originalFileKey).then(response => response.data)
										.then((d) => {
											if(d)
											{
											f.downloadUrl = d.downloadUrl;
											}
											this.setState({previewFile:f});
										});
									}
									//else
									//{
										finalSTL.push(f);

									//}
								}
									
							}
					});

					this.setState({ files:data, tags:tags, finalSTL:finalSTL});
					this.setState({
					statusMap: {
						...this.state.statusMap,
						[fileId]: "verified"
					}
					});

			      //console.log(data);

			     });
				 /*if(this.state.fileTagging === 'Final STL' && meta.name.toLowerCase().includes(".stl"))
				 {
					 getlatestSTlFiles(id).then(response => response.data)
					.then((data)=>
					{

							console.log(data);
							if(data)
							{
								getFile(data.id,data.originalFileKey).then(response => response.data)
								.then((d) => {
									if(d)
									{
									data.downloadUrl = d.downloadUrl;
									}
								this.setState({fileApproval: data});
							});
							}
				
	

					  });
				 }*/
	      });
    }
  }

 toggleMenu(){
 	//console.log("toggleMenu");
    this.setState({ menu: !this.state.menu })
  }

  handleDeleteNotes(notesKey){
	if (window.confirm("Are you sure you want to delete this note?")) 
    {
		console.log("noteskey::",notesKey);
		deleteNotes(notesKey) 
		.then((data) => {
			let notes = this.state.notes;
			let index =  notes.findIndex(x=>x.id === notesKey);
			notes.splice(index,1);
			this.setState({notes});
			//console.log(data);

		});
	}
  }

  fileApprove(fileApproval)
	{
		if (window.confirm("Are you sure you want to approve the file "+fileApproval.fileName+"?")) 
  		{
			approve(fileApproval.id)
			.then((response) => {
				fileApproval.fileApprovedFlag = true;
				this.setState({previewFile:fileApproval});

				this.state.mStatus.filter(sts=> sts.jobStatusId==='JOBS00007').map((fsts)=>{
					this.setState({jobStatus:fsts.jobStatusName})
					console.log("fsts::::",fsts);	
					})
			});
		}
	}
	fileReject(fileApproval)
	{
		if (window.confirm("Are you sure you want to reject the file "+fileApproval.fileName+"?")) 
  		{
			reject(fileApproval.id)
			.then((response) => {
				fileApproval.fileApprovedFlag = false;
				this.setState({previewFile:fileApproval});
					this.state.mStatus.filter(sts=> sts.jobStatusId==='JOBS00008').map((fsts)=>{
					this.setState({jobStatus:fsts.jobStatusName})
					console.log("fsts::::",fsts);	
					})
			});
		}
	}
  

	previous= async () =>{
		this.setState({previewLoading:true});
		console.log("proevious.............."+ this.state.currentPreview,this.state.finalSTL.length)
		console.log("next")
			if(parseInt(this.state.currentPreview)>0)
			{
				let current = parseInt(this.state.currentPreview)-1;
				let nextfile = this.state.finalSTL[parseInt(current)];
				await getFile(nextfile.id,nextfile.originalFileKey).then(response => response.data)
										.then((d) => {
											if(d)
											{
											nextfile.downloadUrl = d.downloadUrl;
											}
											this.setState({previewFile:nextfile,currentPreview:current,previewLoading:false});
										});
				
			}
	}

		next= async () =>{
			this.setState({previewLoading:true});
			console.log("next........."+this.state.currentPreview,this.state.finalSTL.length)
			if(parseInt(this.state.currentPreview)<this.state.finalSTL.length)
			{
				let current = parseInt(this.state.currentPreview)+1;
				let nextfile = this.state.finalSTL[parseInt(current)];
				await getFile(nextfile.id,nextfile.originalFileKey).then(response => response.data)
										.then((d) => {
											if(d)
											{
											nextfile.downloadUrl = d.downloadUrl;
											}
											this.setState({previewFile:nextfile,currentPreview:current,previewLoading:false});
										});
				
			}
		
	}

  
async componentDidMount()
  {

	window.scrollTo(0,0);
	getJobStatus().then(response => response.data)
		.then((data) => {
		  this.setState({ mStatus: data })
		 // console.log(data);
		 });
  	
	//console.log("[rp[d",this.props.location);
    let jobrdbId = this.getQueryVariable("id");
	let patientKey = this.getQueryVariable("key");
	let jobr = null;

	if(this.props.location.data!==undefined && this.props.location.data!==null)
	{
		jobrdbId = this.props.location.data.id;
		patientKey = this.props.location.data.pEntityId;
		jobr = this.props.location.data;

	

	}

  	let tempSchedules=[];
    if(jobrdbId !== null && patientKey!==null)
    {

		this.setState({jobRequestDbId:jobrdbId});
    	getRoles().then(response => response.data)
    .then((data) => {
    	let referralRole='';
    	let practiceRole='';
    	data.filter(x=> x.tag==='Referral').map((role)=>
    	{
    		referralRole = referralRole + "," + role.roleId;
    	});

    	data.filter(x=> x.tag===null).map((role)=>
    	{
    		practiceRole = practiceRole + "," + role.roleId;
    	});
    	console.log("roles class:::::",practiceRole,referralRole);
      this.setState({ Referral:referralRole,Practice:practiceRole })
      //console.log(this.state.users)
     })


	 getJobById(jobrdbId).then(response => response.data)
	 .then((data) => {
	   this.setState({ jobRequest: data})
	  	console.log("job:::::",data);

	  
		if(this.state.mStatus!=null)
		{
			console.log("fsts::::","here",data.jobRequestKey);	
			this.state.mStatus.filter(sts=> sts.jobStatusId===data.jobStatusId).map((fsts)=>{
				this.setState({jobStatus:fsts.jobStatusName})
				console.log("fsts::::",fsts);	
				})
		}										
	
	  });


	    getPatientById(patientKey).then(response => response.data)
	    .then((data) => {
	      this.setState({ patients: data,tStatus:data[0].status,patient:data[0]})
	      //console.log(data[0]);
		  document.title = data[0].firstName + ' ' + data[0].lastName;
	     });


		 getJobFiles(jobrdbId).then(response => response.data)
		 .then((data) => {

			let files = data;
			let tags =[];
			let finalSTL = [];
			files.map(async(f)=> {
				//console.log("file::::::",f);

				if (tags.indexOf(f.fileTag) === -1) {
        			tags.push(f.fileTag)
   				}
				if(f.fileTag.toLowerCase()==="final stl")
				{
					if(f.fileName.includes(".stl")||f.fileName.includes(".png")||f.fileName.includes(".jpg")||f.fileName.includes(".jpeg"))
					{
						if(finalSTL.length===0)
						{
							await getFile(f.id,f.originalFileKey).then(response => response.data)
							.then((d) => {
								if(d)
								{
								f.downloadUrl = d.downloadUrl;
								}
								this.setState({previewFile:f});
							});
						}
						//else
						//{
							finalSTL.push(f);
						//}
					}
						
				}
				
			});

		   this.setState({ files:data, tags:tags, finalSTL: finalSTL})
		   //console.log("files::::",data,finalSTL);

		   //find latest stl file 

		   
		  });

		/*  getlatestSTlFiles(jobrdbId).then(response => response.data)
		  .then((data)=>
		  {

				console.log(data);
				if(data)
				{
					getFile(data.id,data.originalFileKey).then(response => response.data)
					.then((d) => {
						if(d)
						{
						data.downloadUrl = d.downloadUrl;
						}
						this.setState({fileApproval: data});
					});
				}
				
	

		  });*/
 
	   

      getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     });

	    
	     getAccounts().then(response => response.data)
      .then((data) => {
        this.setState({ mAccounts: data })
       // console.log(data);
       });
      /////notes
      getJobNotes(jobrdbId).then((response) => {
      	console.log("notes:::",response);
  		this.setState({notes:response.data})
      });

	





    let fromPath ='';
	if(this.props.location.fromPath!=null) this.setState({fromPath: this.props.location.fromPath});
	if(this.props.location.postObj!=null) this.setState({postObj: this.props.location.postObj});
	if(this.props.location.page!=null) this.setState({page: this.props.location.page});
    
  }
}

render()
{

	const show = (this.state.menu) ? "show" : "" ;
    return (
    	<>

    			
    						{/*patient calendar and patient information*/}
							<div className="row">
								
								<div className="col-lg-6">
									
									{this.state.patients.map((patient) => (
								
							<>
								
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
													{patient.firstName} {patient.lastName} {'Details '}
													
																	
													</h3>
												</div>
											</div>
											<div className="kt-portlet__body">
												<div className="kt-section">
													<div className="kt-section__desc">
														
														<div className="row">
															<div className="col">
																Name :
															</div>
															<div className="col">
																<span className="kt-font-info">{patient.firstName} {patient.lastName}</span>
															</div>
														</div>
														<div className="row">
															<div className="col">
																PID :
															</div>
															<div className="col">
															<span className="kt-font-info">{patient.patientId}</span>
															
															</div>
														</div>
														<div className="row">
															<div className="col">
																DOB :
															</div>
															<div className="col">
															<span className="kt-font-info">{format(new Date(patient.dateOfBirth), 'MM/dd/yyyy')}</span>
																
															</div>
														</div>
														<div className="row">
															<div className="col">
																Mobile :
															</div>
															<div className="col">
															<span className="kt-font-info">{patient.mobile}</span>
																
															</div>
														</div>
														<div className="row">
															<div className="col">
																Referred By :
															</div>
															<div className="col">
																<span className="kt-font-info">
																	{
																		this.state.mAccounts!=null &&  patient.referredAccountKey!==null &&
																		(
																		this.state.mAccounts.filter(acc=> acc.accountId==patient.referredAccountKey).map((facc)=>(
																			facc.accountName
																		))
																		)
																		
																	}
																	{
																		this.state.mAccounts!=null &&  patient.referredAccountKey===null &&
																		(
																		this.state.mAccounts.filter(acc=> acc.accountId==patient.accountKey).map((facc)=>(
																			facc.accountName
																		))
																		)
																		
																	}
																</span>
															</div>

														</div>
														<div className="row">
															<div className="col">
																Referred To :
															</div>
															<div className="col">
																<span className="kt-font-info">
																	{this.state.referredTo!==null? this.state.referredTo : ' '}
																	{this.state.referredToAccountKey!==undefined && this.state.referredToAccountKey!==null && this.state.mAccounts.filter(acc=> acc.accountId==this.state.referredToAccountKey).map((facc)=>(
																			' ('+facc.accountName+')'
																		))}
																</span>
															</div>
														</div>
														<div className="row">
															<div className="col">
																Batch Number :
															</div>
															<div className="col">
																<span className="kt-font-info">
																	{patient.batchNumber}
																</span>
															</div>
														</div>
														<div className="row">
															<div className="col">
																Lot Number :
															</div>
															<div className="col">
																<span className="kt-font-info">
																	{patient.lotNumber}
																</span>
															</div>
														</div>
														<div className="row">
															<div className="col">
																Implant :
															</div>
															<div className="col">
															<span className="kt-font-info">{this.state.jobRequest!==null && this.state.jobRequest.implantTypesDisplay!==null && this.state.jobRequest.implantTypesDisplay.join(", ")}</span>
																
															</div>
														</div>
														<div className="row">
															<div className="col">
																Treatment Recommendations :
															</div>
															<div className="col">
															<span className="kt-font-info">{this.state.jobRequest!==null &&  this.state.jobRequest.treatmentPlansDisplay!==null &&  this.state.jobRequest.treatmentPlansDisplay.join(", ")}</span>
																
															</div>
														</div>
														<div className="row">
															<div className="col">
																Location :
															</div>
															<div className="col">
															<span className="kt-font-info">{this.state.jobRequest!==null && this.state.jobRequest.locationName!==null && this.state.jobRequest.locationName}</span>
																
															</div>
														</div>
														<div className="row">
															<div className="col">
																Job Status : 
																</div>
																<div className="col">
																<span className="kt-font-info">
																	{this.state.jobStatus+ ' '}
																	<Tooltip title="Update Status"><IconButton onClick={()=>this.setState({statusOpen:true})} >
																		<EditIcon style={{ color: '#5578eb',fontSize: 14}}/>  
																	</IconButton>
																															
																	</Tooltip>
																	</span>
																</div>
														</div>
													</div>
													
													
												</div>
											</div>
										</div>

{/**file approval and preview */}
											{this.state.previewFile !==null &&
											<div className="kt-portlet">
										<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
													 {'Digital Planning Status (' + this.state.previewFile.fileName + ') '}
													 {this.state.previewFile.fileApprovedFlag===null && '- Not Approved'}
													 {this.state.previewFile.fileApprovedFlag!==null && this.state.previewFile.fileApprovedFlag && ' - Approved'}
													 {this.state.previewFile.fileApprovedFlag!==null && !this.state.previewFile.fileApprovedFlag && ' - Rejected'}
													
																	
													</h3>
												</div>
											</div>
										<div className="kt-portlet__body">
											<div className="row">
												<div className="col-md-8">
													
													{this.state.finalSTL!==null && this.state.finalSTL.length>0 && <>
													{parseInt(this.state.currentPreview)>0 &&
													<Tooltip title="Previous"><a href='#' onClick={()=>this.previous()} >
																	<IconButton>
																		<SkipPreviousIcon style={{ color: '#87ca1a' }} size={24} />
																	</IconButton>
																	</a> 
																</Tooltip>}
																{parseInt(this.state.currentPreview)<(this.state.finalSTL.length-1) &&
													<Tooltip title="Next"><a href='#' onClick={()=>this.next()} >
																	<IconButton>
																		<SkipNextIcon style={{ color: '#87ca1a' }} size={24} />
																	</IconButton>
																	</a> 
																</Tooltip>}
													</>}
													{this.state.previewLoading &&
													  <CircularProgress/>
													}
													{this.state.previewLoading===false && this.state.previewFile!==null && this.state.previewFile.fileName.includes(".stl") &&
													<iframe scrolling="no" frameborder="0"  height="300px" width="100%" src={"https://mpestlviewer.s3.us-east-1.amazonaws.com/thumb.html?id="+encodeURIComponent(this.state.previewFile.downloadUrl)}></iframe>
													}
													{this.state.previewLoading===false && this.state.previewFile!==null && (this.state.previewFile.fileName.includes(".png") || this.state.previewFile.fileName.includes(".jpg") ||this.state.previewFile.fileName.includes(".jpeg") ) && 
														<img src={this.state.previewFile.downloadUrl} alt="image" style={{width:'100%',height:'300px'}}/>
													}
												</div>
												{this.state.previewFile.fileApprovedFlag===null && 
												<div className="col-md-3" style={{verticalAlign:'middle'}}>
													<div className="row" style={{alignItems:'center', justifyContent:'center', fontWeight:'bold',color:'black',padding:
														'30px',textAlign:'center'}}>
															<div  className="col">
																<Tooltip title="Approve"><a href='#' onClick={()=>this.fileApprove(this.state.previewFile)} >
																	<IconButton>
																		<ThumbUpAltIcon style={{ color: '#87ca1a' }} size={24} />
																	</IconButton>
																	</a> 
																</Tooltip>
																
														</div>
														<div className="col">
														Yes
														</div>
													</div>
													<div className="row" style={{fontWeight:'bold',color:'black', padding:
														'30px',textAlign:'center'}}>
															<div className="col" style={{alignItems:'center'}}>
																	<Tooltip title="Reject"><a href='#' onClick={()=>this.fileReject(this.state.previewFile)} >
																	<IconButton>
																	<ThumbDownAltIcon style={{ color: '#ec5242' }} size={24} />
																	</IconButton></a>
																	</Tooltip>
																	
															</div>
															<div className="col" style={{alignItems:'center'}}>
																No
															</div>

														
													
													</div>
												</div>
												}
											</div>
											<div className="row">
												<div className="col-md-12">
													 {/*<FormControlLabel control={<Checkbox  value={'sendto'} name={'sendto'} />}
														           label={'Planner'} 
													 />
													 <FormControlLabel control={<Checkbox  value={'sendto'} name={'sendto'} />}
														           label={'Lab'} 
													 />
													 <FormControlLabel control={<Checkbox  value={'sendto'} name={'sendto'} />}
														           label={'Manufacturer'} 
													 />*/}
												</div>
											</div>
										</div>
									</div>}
										</>
									))}
								</div>
								<div className="col-lg-6">
								
								
								<div className="kt-portlet kt-portlet--height-fluid">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													
													<h3 className="kt-portlet__head-title">
														Documents/Images
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													<div className="kt-portlet__head-group">
														<div className="btn-group">
															<button type="button" className="btn btn-elevate btn-danger" onClick={ this.handleOpen } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="la la-plus"></i> Add Docs/Images
															</button>
															
														</div>
													</div>
												</div>
											</div>
											<div className="kt-portlet__body">
												
												<div className="kt-section">
													{/*<h3>Files</h3>*/}
													<div className="kt-section__content">
														
														<div className="kt-widget4">
														{this.state.tags!==null && this.state.tags.length>0 &&  this.state.tags.map((t)=>(
															<>
															<div className="kt-widget4__item">
																 <span className="kt-widget4__icon">
                													<i className="flaticon-folder-1 kt-font-warning" />
              													</span>
																<a className="kt-widget4__title" style={{'pointer-events': 'none'}}
																	href="#" 
																	>
																		{t===null ? 'Untagged Files' : t}
																		</a>

																
															</div>
															{this.state.files !==null && this.state.files.filter(x=>x.fileTag===t).map((file)=>(
															 <div className="kt-widget4__item">
																<div className="kt-widget4__pic kt-widget4__pic--pic">
																	<DescriptionOutlinedIcon style={{ color: '#5578eb',fontSize: 18}}/>  
																</div>
																	
																	 <div className="kt-widget4__info">
																		<a
                  															className="kt-widget4__username"
																		href="#"
																		/>
																		{file.fileName.includes(".stl") &&
																		<a
																		className="kt-widget4__title"
																		href="#" onClick={()=>this.stlView(file.id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)}
																		>
																		{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																		</a>
																		}
																		{!file.fileName.includes(".stl") &&
																		<a
																		className="kt-widget4__title"
																		href="#" onClick={()=>this.imageView(file.id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)}
																		>
																		{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																		</a>
																		}
																		<p className="kt-widget4__text">{file.createdByUserName!=null && file.createdByUserName + "," + format(new Date(file.lastUpdatedOn),"MM/dd/yyyy hh:mm")}</p>
																	</div>
																<span className="kt-widget4__number kt-font-brand">
																		{!file.fileDeleteAllowed && 
																	<Tooltip
																		title= "Delete File"
																		>
																		<DeleteIcon style={{ cursor: 'pointer', color: '#5578eb',fontSize: 20}} onClick={(e) => this.handleDeleteFile(file.id)}/>   
																		
																		</Tooltip>
																		}
																</span>
																
																</div>											
															
															
															))}
															
														</>
														))}
														
														</div>
														</div>
														
													</div>
												</div>
												
											
											</div>
										</div>
							
								</div>
									
						
										
							<div className="row">
								<div className="col">
									
										<div className="kt-portlet">
										<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
													 {'Tooth Chart'}
													
																	
													</h3>
												</div>
											</div>
										<div className="kt-portlet__body">
											<div className="row">
												<div className="col">
														<FormControl component="fieldset">
														       
														         <div class="container" style={{'background-color':'#0B6CAF'}}>
														        <div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row>
														          {this.state.extractionTop!==null && this.state.extractionTop.values.map((val,index)=>(
														          		<div className="col" style={{'border': '1px solid grey','width':'63px'}}>
																			
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={this.state.extractionTop.imagePath[index]}
													              		/>}
													              	style={{'margin-left':'0px'}} />
																	{this.state.jobRequest!==null && this.state.jobRequest.extractionTop !=null && this.state.jobRequest.extractionTop.some(v=>v===val) &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange}  style={{'margin-left':'0px','color':'white'}} value={val} name={'extractionTop'} checked />}
														            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}
														          />
														      	  }
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														         </div>
														    															    	

																
														       
														        <div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row>
														          {this.state.extractionBottom !==null && this.state.extractionBottom.values.map((val,index)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'63px'}}>
																		
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={this.state.extractionBottom.imagePath[index]}
													              		/>}
													              	style={{'margin-left':'0px'}} />
																	{this.state.jobRequest!==null && this.state.jobRequest.extractionBottom !=null && this.state.jobRequest.extractionBottom.some(v=> v===val) &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange}  style={{'margin-left':'0px','color':'white'}} value={val} name={'extractionBottom'} checked />}
														            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}
														          />
														      	  }
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														        </div>
														    	

														        </div>
													      </FormControl>
												</div>
											</div>
											
										</div>
									</div>
									</div>

							</div>
								
									
									<div className="row">
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													<h3 className="kt-portlet__head-title">
														Tooth # / Notes
													</h3>
												</div>
											</div>
											<div className="kt-chat">
												<div className="kt-portlet__body">
													<div className="kt-scroll kt-scroll--pull" style={{'min-height':'200px','max-height':'350px','overflow':'auto'}} data-mobile-height="300">
														{this.state.notes!=null && this.state.notes.map((notes)=>(
														<div className="kt-chat__messages">
															<div className="kt-chat__message">
																<div className="kt-chat__user">
																	{/*<span className="kt-media kt-media--circle kt-media--sm">
																		<img src="media/users/default.jpg" alt="image"/>
														</span>*/}
																	{/*<a href="#" className="kt-chat__username">{notes.createdByFirstName + ' ' + notes.createdByLastName}</a>*/}
																	<span className="kt-chat__datetime">
																    {this.state.permission.includes("NOTES:DELETE") &&
																	<Tooltip
																		title= "Delete Notes"
																		>
																		<DeleteIcon style={{ color: '#5578eb',fontSize: 20}} onClick={(e) => this.handleDeleteNotes(notes.id)}/>   
																		
																		</Tooltip>
																	}
																		{notes.createdByFirstName + ' ' + notes.createdByLastName + ' '}{format(new Date(notes.createdOn), 'MM/dd/yyyy hh:mm')}
																	
																	</span>
																	
																</div>
																<div className="kt-chat__text kt-bg-light-success">
																
																	{notes.notes}
																	
																</div>
															</div>
														</div>
														))}
													</div>
													
												</div>
												<div className="kt-portlet__foot">
													<div className="kt-chat__input">
														<div className="kt-chat__editor">
														   
															<textarea
									                          margin="normal"
									                          placeholder="Type your notes here"
									                          name="message"
									                          rows={5}
												              onChange={(e)=>this.setState({input:e.target.value})}
												              value={this.state.input}
												              style={{borderStyle:'solid', backgroundColor:'grey', borderColor: 'black', border: '1px solid black'}}
									                        />
														</div>
														<div className="kt-chat__toolbar">
															<div className="kt_chat__actions">
																<button type="button" onClick={this.sendMessage} className="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply">Add Notes</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										</div>
										
									</div>

									
							
									

						{/**status update */}
							{this.state.jobRequest!=null &&
									<Dialog fullWidth={true}
									maxWidth={'xs'} open={this.state.statusOpen} onClose={()=>this.setState({statusOpen:false})} aria-labelledby="form-dialog-title">
								   
									<DialogTitle id="form-dialog-title">{'Digital Planning Status Update'}</DialogTitle>
									<DialogContent>
									  <EditJobrStatus jobRequest={this.state.jobRequest} onUpdate={()=>this.updateStatus(this.state.jobRequest)} />
									</DialogContent>
								  
							
									<DialogActions>
									  <Button onClick={()=>this.setState({statusOpen:false})} color="primary">
										Close
									  </Button>
									
									 
									 
									</DialogActions>
									 
								  </Dialog>		
								  }		
						
							{/**file upload */}
							<Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
 
						        <DialogTitle id="form-dialog-title">Drag & Drop documents/images to upload</DialogTitle>

								

						        <DialogContent>
						          {<DialogContentText>
						            File(s) like DICOM and any other images that have multiple files must be compressed as “.zip” before upload.
						          </DialogContentText>}

									 {/*this.state.jobRequest!==null && this.state.jobRequest.treatmentPlans!==null &&
								  <FormControl component="fieldset">
									<FormLabel component="legend"><b>Treatment Recommendations: </b>{this.state.jobRequest.treatmentPlans.join(", ")}</FormLabel>
								  </FormControl>
									*/}
									<br/>
								

								  <FormControl component="fieldset">
									<FormLabel component="legend">Select File Tag</FormLabel>
									<RadioGroup row aria-label="fileTag" name="fileTag" value={this.state.fileTagging} onChange={this.handleChange}>
										<FormControlLabel value="Source Files" control={<Radio />} label="Source Files" />
										<FormControlLabel value="Specialist Approval Files" control={<Radio />} label="Specialist Approval Files" />
										<FormControlLabel value="GP Approval Files" control={<Radio />} label="GP Approval Files" />
										<FormControlLabel value="Final STL" control={<Radio />} label="Final STL" />
									</RadioGroup>
									</FormControl>
								
								  {this.state.fileTagging!==null &&
						          <Dropzone
						          	accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.mp3,.zip,.stl,.bsb"
									//LayoutComponent={this.Layout}
									PreviewComponent={(props) => (
										<FileUploadPreview
										{...props}
										customStatus={this.state.statusMap[props.meta.id]}
										/>)}
						          	onChangeStatus={this.handleChangeStatus}
								    getUploadParams={this.getUploadParams}
									styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
								   />
								   }
								  {this.state.fileTagging===null &&
								   <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
															  <Alert severity="warning">&nbsp;&nbsp;File tagging is required. Kindly select file tag.</Alert>      
															</div>
								  }

						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.handleClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

      		
							 

						
						    {/**image viewer */}
      						<Dialog open={this.state.imageOpen}  aria-labelledby="form-dialog-title" >
 
						        <DialogTitle id="form-dialog-title">Document/Image Viewer
						        			{this.state.status && ' - Annotation saved successfully!!'}
						        </DialogTitle>
						        <DialogContent>

									 {this.state.fileType!=null && this.state.fileType.includes("image") &&
																	
																	 
										<img  src={this.state.imageUrl}
											alt='image view'
												
																/>
									 }
                            {this.state.fileType!=null && !this.state.fileType.includes("image") && !this.state.fileType.includes("audio") &&
                            	<span style={{'text-align':'center'}}>
								<img src="media/icons/svg/Files/File.svg"/>
								</span>
																
                            }
                     
						        </DialogContent>
      

						        <DialogActions>
								

								

						       
						     
						        <Button color="primary">
						            <a href={this.state.imageUrl} target="_blank">Download</a>
						          </Button>
						        
							
						          <Button onClick={this.imageClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

							{/**stl viewer */}
							{this.state.imageUrl!=null && 
							<Dialog fullScreen 
							theme={{ colors: { background: 'black' } }} 
							style={{backgroundColor: 'black'}}
								open={this.state.stlOpen}  aria-labelledby="form-dialog-title" >
						        <DialogContent>
						         		<iframe scrolling="no" frameborder="0"  height="100%" width="100%" src={"https://mpestlviewer.s3.us-east-1.amazonaws.com/index.html?id="+encodeURIComponent(this.state.imageUrl)}></iframe>
						        </DialogContent>

								
						        <DialogActions>
									<Button color="primary">
						            	<a href={this.state.imageUrl} target="_blank">Download</a>
						          </Button>
									<Button size="large" variant="contained"  onClick={()=>this.setState({stlOpen:false})} color="secondary">
						            	Close
						          	</Button>
						        </DialogActions>
      					        
      						</Dialog>
							}

    	</>
    	);
	}   
}